<script>
    import { onMount } from 'svelte';
    import { approvalInfo } from './diffStore.js';

    import ApprovalSummary from './DiffSummary/ApprovalSummary.svelte';
    import RiskRating from './DiffSummary/RiskRating.svelte';
    import MaterialRisk from './DiffSummary/MaterialRisk.svelte';
    import SummaryNav from './DiffSummary/SummaryNav.svelte';

    export let reviewerSummary;
    export let controlOwnerSummary;
    export let strategyApproverSummary;
    export let activityApproverSummary;

    let activeComponent = 'reviewSummary';

    onMount(() => {
        if ($approvalInfo?.diffType === 'CONTROL') {
            activeComponent = "materialRisk";
        }
    })

</script>

<div class="summary-screen">
  <SummaryNav bind:activeComponent />
  <div class="content">
    {#if activeComponent === 'reviewSummary'}
      <ApprovalSummary
        {reviewerSummary}
        {controlOwnerSummary}
        {strategyApproverSummary}
        {activityApproverSummary}
      />
    {:else if activeComponent === 'riskRating'}
      <RiskRating />
    {:else}
      <MaterialRisk />
    {/if}
  </div>
</div>

<style>
  .content {
    padding-top: 0.5rem;
  }
</style>
